/** Shared helpers for the Billing pages. */

/** ₹ in "Rs." Indian format, no decimals (matches portal convention). */
export const rs = (n: number): string => 'Rs. ' + Number(n || 0).toLocaleString('en-IN');

export const isYearlyPeriod = (period: string): boolean => {
  const p = (period || '').toLowerCase();
  return p.includes('year') || p.includes('annual');
};

export type PlanCategory = 'token' | 'provider' | 'bundle';

export const typeBadge = (type: string): { bg: string; fg: string; label: string } => {
  switch (type) {
    case 'token': return { bg: '#FFFBEB', fg: '#D97706', label: 'Token' };
    case 'provider': return { bg: '#F5F3FF', fg: '#7C3AED', label: 'Provider' };
    default: return { bg: '#EFF6FF', fg: '#065CC6', label: 'Bundle' };
  }
};

export const fmtDate = (d: string): string =>
  d ? new Date(d.length <= 10 ? d + 'T00:00:00' : d).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';
